import { Login } from "../../components/Pages/Login";

export const LoginPage = () => {
  return <Login />;
};
